import { Navigate, Outlet, useLocation } from 'react-router-dom'

import { useHealth, useMe } from '@/api/queries'
import { Skeleton } from '@/components/ui/primitives'

export function AuthGate() {
  const location = useLocation()
  const health = useHealth()
  const mode = (health.data?.checks?.auth as { mode?: string } | undefined)?.mode
  const me = useMe()

  if (health.isLoading || (mode && mode !== 'disabled' && me.isLoading)) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Skeleton className="h-10 w-48" />
      </div>
    )
  }

  if (mode && mode !== 'disabled' && me.error) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />
  }

  return <Outlet />
}
